import React, { useState } from "react";
import {
  FilterableCounts,
  FilterOptions,
  FilterQuery,
  TextParameterMap,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { BooleanParameterFilterControls } from "./boolean_parameter_filter_controls";
import { NumericParameterFilterControls } from "./numeric_parameter_filter_controls";
import { applyParameterFilter } from "../helpers/parameter_filter_utils";
import { TextParameterFilterControls } from "./text_parameter_filter_controls";
import {
  ParameterFilterChangeHandler,
  ParameterFilterRemoveHandler,
} from "../types";
import ParameterHintModal from "./parameter_hint_modal";

type ParameterFiltersControlsProps = {
  parameters: FilterOptions["parameters"];
  filteredParameters: FilterQuery["parameters"];
  filteredBooleanParameters: FilterQuery["booleanParameters"];
  onChange: (newParameterFilter: FilterQuery["parameters"]) => void;
  onBooleanChange: (
    newBooleanParameterFilter: FilterQuery["booleanParameters"]
  ) => void;
  onRemove: ParameterFilterRemoveHandler;
  numericParameterRanges: FilterableCounts["numericParameters"];
  textParameterOptions: FilterableCounts["textParameters"];
  booleanParameterOptions: FilterableCounts["booleanParameters"];
  allTextParameterValues: TextParameterMap;
};

export const ParameterFiltersControls = ({
  parameters,
  filteredParameters,
  filteredBooleanParameters,
  numericParameterRanges,
  textParameterOptions,
  booleanParameterOptions,
  allTextParameterValues,
  onChange,
  onBooleanChange,
  onRemove,
}: ParameterFiltersControlsProps) => {
  const changeHandler: ParameterFilterChangeHandler = (
    parameterId,
    parameterFilter
  ) => {
    onChange(
      applyParameterFilter(parameterFilter, parameterId, filteredParameters)
    );
  };

  const booleanChangeHandler = (
    parameterId: number,
    newFilterValue: boolean
  ) => {
    onBooleanChange({
      ...filteredBooleanParameters,
      [parameterId]: newFilterValue,
    });
  };

  const [hintIsShown, setHintIsShown] = useState(false);
  const [hintDescription, setHintDescription] = useState<string>(
    "popis parametru"
  );

  const showHint = (description: string) => {
    setHintIsShown(true);
    setHintDescription(description);
  };

  const hideHint = () => {
    setHintIsShown(false);
    setHintDescription("");
  };

  return (
    <div className="extra-filters">
      {hintIsShown && (
        <ParameterHintModal onClose={hideHint} description={hintDescription} />
      )}
      {parameters.map((parameter) => {
        if (parameter.valueType === "text") {
          return (
            <TextParameterFilterControls
              key={parameter.id}
              parameter={parameter}
              filterableCounts={textParameterOptions}
              allValues={allTextParameterValues[parameter.id]}
              filteredParameters={filteredParameters}
              onChange={changeHandler}
              onShowHint={showHint}
            />
          );
        } else if (parameter.valueType === "num") {
          if (numericParameterRanges[parameter.id] === undefined) {
            return null;
          }
          return (
            <NumericParameterFilterControls
              key={parameter.id}
              parameter={parameter}
              range={numericParameterRanges[parameter.id]}
              filteredParameters={filteredParameters}
              onChange={changeHandler}
              onShowHint={showHint}
            />
          );
        } else if (parameter.valueType === "bool") {
          return (
            <BooleanParameterFilterControls
              onRemove={onRemove}
              key={parameter.id}
              parameter={parameter}
              filteredParameters={filteredBooleanParameters}
              filterableCounts={booleanParameterOptions}
              onChange={booleanChangeHandler}
              onShowHint={showHint}
            />
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};
